<div *ngFor="let alert of alerts" class="{{ cssClass(alert) }} alert-dismissable">
  {{alert.message}}
  <button mat-icon-button class="close" (click)="removeAlert(alert)">
    <mat-icon>close</mat-icon>
  </button>
</div>

